angular
    .module('cabinetApp')
    .factory('widgetsModel', function($http) {
        var widgetsModel = {};

        // Получить данные для уведомлений
        widgetsModel.getData = function(data, success, error) {
            return $http
                .get('/api/v4/cabinet/lk_notices/', { params: data })
                .then(function (response) {
                    response.data.debts.forEach((value) => {
                        value.debt = Number.parseFloat(
                            (value.debt / 100).toFixed(2)
                        );
                    });
                    return response['data'];
                })
                .then(success, error);
        };

        return widgetsModel;
    });